import axios from "axios";

const api = axios.create({
  baseURL: "https://job-tracker-92ht.onrender.com/api",
  withCredentials: true, // ✅ important for CORS
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error("API ERROR:", err.response || err.message);
    return Promise.reject(err);
  }
);

export default api;